import React, { useState } from "react";
import { Box, Pagination } from "@mui/material";
import { DataTable } from "./Common";

// DataTable + Pagination.
//  server mode (default): `rows` is the current page, `total` the server-side count, `page`/`onPage` owned by the parent.
//  client mode (mode="client"): `rows` is the whole array; the component slices it and owns the page state
//  (unless `page`/`onPage` are given).
export default function PagedTable({ columns, rows, getRowKey, total, page, pageSize = 50, onPage, mode = "server", sx }) {
    const [localPage, setLocalPage] = useState(1);
    const all = rows || [];
    const count = mode === "client" ? all.length : (total ?? all.length);
    const pageCount = Math.max(1, Math.ceil(count / pageSize));
    const cur = Math.min(page ?? localPage, pageCount);
    const view = mode === "client" ? all.slice((cur - 1) * pageSize, cur * pageSize) : all;
    const change = (_, p) => { if (onPage) onPage(p); else setLocalPage(p); };
    return (
        <>
            <DataTable columns={columns} rows={view} getRowKey={getRowKey} sx={sx} />
            {pageCount > 1 && <Box sx={{ display: "flex", justifyContent: "center", mt: 1, mb: 2 }}>
                <Pagination count={pageCount} page={cur} onChange={change} size="small" />
            </Box>}
        </>
    );
}
